import React, { useEffect, useRef, useState } from 'react';
import './WarningVidas.css';

export default function WarningVidas({
  lives,
  levelKey,
  triggerAt = 2,
  message = 'Los pacientes están reclamando por tu atención... Te quedan 2 oportunidades!',
  title = '¡Atención!',
  imageKey = 'enfermera_molesta',
  resolveImg,
  onOpen,
  onClose,
  canShow = true,
  debug = true,
}) {
  const [visible, setVisible] = useState(false);

  // El aviso se controla por partida (montaje del componente), no por navegador.
  // Así vuelve a estar disponible cuando el jugador inicia una nueva partida.
  const alreadyShownRef = useRef(false);
  const armedRef = useRef(false);

  // Mantener las últimas funciones entregadas por el nivel sin reabrir el aviso
  // cada vez que el padre se renderiza.
  const onOpenRef = useRef(onOpen);
  const onCloseRef = useRef(onClose);
  onOpenRef.current = onOpen;
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!debug) return;
    console.debug('[WarningVidas] mount', { levelKey, triggerAt, lives });
  // Solo diagnóstico del montaje, como en la versión original.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (typeof lives !== 'number') return;

    if (debug) {
      console.debug('[WarningVidas] evaluate', {
        lives,
        triggerAt,
        alreadyShown: alreadyShownRef.current,
        canShow,
        visible,
        armed: armedRef.current,
      });
    }

    // El umbral se registra aunque en ese instante haya feedback o error.
    if (lives === triggerAt && !alreadyShownRef.current) {
      armedRef.current = true;
      if (debug && !canShow) {
        console.debug('[WarningVidas] ARMED (esperando canShow=true)');
      }
    }

    // Si quedó pendiente, se abre en cuanto el nivel permita mostrarlo.
    // El ref se marca ANTES de actualizar React para evitar aperturas dobles.
    if (armedRef.current && canShow && !alreadyShownRef.current) {
      alreadyShownRef.current = true;
      armedRef.current = false;
      if (debug) console.debug('[WarningVidas] OPEN modal');
      setVisible(true);
      if (onOpenRef.current) onOpenRef.current();
    }
  }, [lives, triggerAt, canShow, visible, debug]);

  useEffect(() => {
    if (!debug) return;
    console.debug('[WarningVidas] visible changed ->', visible);
  }, [visible, debug]);

  const imgSrc = resolveImg ? resolveImg(imageKey) : undefined;

  if (!visible) return null;

  return (
    <div className="hw-overlay" role="dialog" aria-modal="true">
      <div className="hw-card">
        <div className="hw-header">
          <span className="hw-title">{title}</span>
        </div>

        <div className="hw-body">
          {imgSrc ? (
            <img className="hw-avatar" src={imgSrc} alt="Enfermera molesta" />
          ) : (
            <div className="hw-avatar hw-avatar-fallback">👩‍⚕️</div>
          )}
          <p className="hw-text">{message}</p>
          <p className="hw-subtext">Respira y concéntrate, Te necesitamos!.</p>
        </div>

        <div className="hw-actions">
          <button
            type="button"
            className="hw-btn"
            onClick={() => {
              if (debug) console.debug('[WarningVidas] CLOSE modal');
              setVisible(false);
              if (onCloseRef.current) onCloseRef.current();
            }}
          >
            Ok. Volvamos a ver pacientes
          </button>
        </div>
      </div>
    </div>
  );
}
